import { sessionStorage } from '../../../shared/utils/storage/storage';

import { SELECTED_PRODUCT_AVAILABILITY_STORE } from '../../../shared/constants/storage-keys';

export function setSelectedProductAvailabilityStore(product) {
  if (!product) {
    return null;
  }
  return sessionStorage(SELECTED_PRODUCT_AVAILABILITY_STORE, {
    availabilityStoreCode: product.stock?.storeCode,
    pdpUrl: product.url,
    plpUrl: window.location.pathname + window.location.search
  });
}
